import { gql } from '@apollo/client'

export default gql(`
    query getPresignedCsvUrl($key: String, $project:String){
        getPresignedCsvUrl(key : $key project: $project) {
            bucket
            key
            region
            url
            uploadUrl
        }
    }`
)
